import { LitElement, css, unsafeCSS } from 'lit';
import styles from './overlay.scss?inline';
import { FIXED_BODY_CLASS, SHOW_ATTRIBUTE } from '../constants';

export default class SotbitOverlay extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static overlays = [];

    static properties = {
        isShow: { type: Boolean, reflect: true, attribute: 'show' },
    };

    constructor() {
        super();

        this.promise = null;
    }

    attributeChangedCallback(name, old, value) {
        super.attributeChangedCallback(name, old, value);

        if (name === SHOW_ATTRIBUTE && old !== value) {
            if(this.isShow) {
                this.show();
            } else {
                this.hide();
            }
        }
    }

    /**
     * @returns Promise
     */
    show() {
        document?.body?.classList?.add(FIXED_BODY_CLASS);

        this.setAttribute(SHOW_ATTRIBUTE, '');

        if (this._promise instanceof Promise) {
            return this._promise;
        } else {
            return this._createPromise();
        }
    }

    /**
     * @returns Promise
     */
    hide() {
        if (!this._getOtherOpenOverlays().length) {
            document?.body?.classList?.remove(FIXED_BODY_CLASS);
        }

        this.removeAttribute(SHOW_ATTRIBUTE);

        if (this._promise instanceof Promise) {
            return this._promise;
        } else {
            return this._createPromise();
        }
    }

    /**
     * @returns SotbitOverlay[]
     */
    _getOtherOpenOverlays() {
        return SotbitOverlay.overlays.filter((element) => {
            return element.getAttribute(SHOW_ATTRIBUTE) !== null;
        });
    }

    /**
     * @returns Promise
     */
    _createPromise() {
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });

        return this._promise;
    }

    _handleTransitionEnd = () => {
        this._resolve();
        this._promise = null;
    };

    connectedCallback() {
        super.connectedCallback();

        SotbitOverlay.overlays.push(this);

        this.addEventListener('transitionend', this._handleTransitionEnd);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        SotbitOverlay.overlays = SotbitOverlay.overlays.filter((element) => element !== this);

        this.hide();
    }
}
